import { useQuery } from '@tanstack/react-query';
import * as proxyApi from '@/api/proxy';

/**
 * Query keys for proxy-related queries
 */
export const proxyKeys = {
  all: ['proxy'] as const,
  userProxy: (userId: string) => [...proxyKeys.all, 'user', userId] as const,
};

/**
 * Hook to get user's assigned proxy IP
 */
export const useUserProxyIp = (userId: string | undefined) => {
  return useQuery({
    queryKey: proxyKeys.userProxy(userId || ''),
    queryFn: () => proxyApi.getUserProxyIp(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};

